import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../../../services/api';
import { FiArrowLeft } from 'react-icons/fi';
import { useLanguage } from '../../../contexts/LanguageContext';
import {
  Container,
  Header,
  Title,
  BackButton,
  DivDetailCard,
  DetailCard,
  DetailItem,
  DetailLabel,
  DetailValue,
  DetailSection,
  SectionTitle,
  OrganizationImage
} from './styles';
import Tooltip from '../../../components/tooltip';
import Loading from '../../../components/Loading';

interface Organization {
  _id: string;
  nameOrganization: string;
  cnpjTaxId: string;
  email: string;
  logoUrl: string;
  nameContact: string;
  phoneContact: string;
  planos: any[];
}

const OrganizationDetails: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { id } = useParams<{ id: string }>();
  const [organization, setOrganization] = useState<Organization | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const fetchRef = useRef(false);

  useEffect(() => {
    const fetchOrganization = async () => {
      if (fetchRef.current) return;
      fetchRef.current = true;

      setIsLoading(true);
      try {
        const token = localStorage.getItem('@App:token');
        const response = await api.get(`/api/organization/${id}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        setOrganization(response.data);
      } catch (error) {
        console.error('Error loading organization:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrganization();
  }, [id]);

  const handleBack = () => {
    navigate('/organizations');
  };

  return (
    <Container>
        <Header>
          <Tooltip text={t('form.org.backToOrganizations')}>
            <BackButton onClick={handleBack}>
              {FiArrowLeft({ className: "icon", size: 30 })}
            </BackButton>
          </Tooltip>
        </Header>

      {isLoading ? (
        <Loading />
      ) : organization ? (
        <DivDetailCard>
          <Title>{t('form.org.organizationDetails')}</Title>

          <DetailCard>
            {/* <OrganizationImage 
              // src={organization.logoUrl || '/BG Sinergy.png'} 
              src={'/BG Sinergy.png'} 
              alt={organization.nameOrganization} 
            /> */}
            
            <DetailSection>
              <DetailItem>
                <DetailLabel>{t('form.org.name')}</DetailLabel>
                <DetailValue>{organization.nameOrganization}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>{t('form.org.cnpjTaxId')}</DetailLabel>
                <DetailValue>{organization.cnpjTaxId}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>{t('form.org.email')}</DetailLabel>
                <DetailValue>{organization.email}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>{t('form.org.contactName')}</DetailLabel>
                <DetailValue>{organization.nameContact}</DetailValue>
              </DetailItem>
              <DetailItem>
                <DetailLabel>{t('form.org.phone')}</DetailLabel>
                <DetailValue>{organization.phoneContact}</DetailValue>
              </DetailItem>
            </DetailSection>
            
          </DetailCard>
        </DivDetailCard>
      ) : (
        <div>{t('form.org.organizationNotFound')}</div>
      )}
    </Container>
  );
};

export default OrganizationDetails; 